__turbopack_context__.v({
  "bg": "BlockCarouselShowcase-module-scss-module__CrObEW__bg",
  "buttonWrapper": "BlockCarouselShowcase-module-scss-module__CrObEW__buttonWrapper",
  "column": "BlockCarouselShowcase-module-scss-module__CrObEW__column",
  "ctaLockup": "BlockCarouselShowcase-module-scss-module__CrObEW__ctaLockup",
  "fade-in": "BlockCarouselShowcase-module-scss-module__CrObEW__fade-in",
  "inner": "BlockCarouselShowcase-module-scss-module__CrObEW__inner",
  "nav": "BlockCarouselShowcase-module-scss-module__CrObEW__nav",
  "navCount": "BlockCarouselShowcase-module-scss-module__CrObEW__navCount",
  "navItem": "BlockCarouselShowcase-module-scss-module__CrObEW__navItem",
  "root": "BlockCarouselShowcase-module-scss-module__CrObEW__root",
});
